'use client'

import { useEffect, useState } from 'react'

type Props = {
  date: string
  timeLimit?: number
}

export function LifeTimeSinceClientNumber({ date, timeLimit = 60 }: Props) {
  const [mins, setMins] = useState(() => getMinutesSince(date))

  useEffect(() => {
    const update = () => setMins(getMinutesSince(date))

    const now = Date.now()
    const msToNextMinute = 60000 - (now % 60000)

    const timeout = setTimeout(() => {
      update()
      ;(cleanup as any).interval = setInterval(update, 60000)
    }, msToNextMinute)

    function cleanup() {
      clearTimeout(timeout)
      if ((cleanup as any).interval) clearInterval((cleanup as any).interval)
    }

    return cleanup
  }, [date])

  if (mins >= timeLimit) return null

  if (mins <= 1) return <>jetzt</>

  return <>vor {mins} Minuten</>
}

function getMinutesSince(date: string) {
  const published = new Date(date).getTime()
  const now = Date.now()
  return Math.max(0, Math.floor((now - published) / 60000))
}
